/**
 * External dependencies
 */
import { omit } from 'lodash';

/**
 * Internal dependencies
 */
import { getAnalyticsDataKey } from '@/utils/analytics';

export default {
    props: {
        waitUntilReady: {
            default: false,
            type: Boolean,
        },
        ready: {
            default: true,
            type: Boolean,
        },
    },

    data: () => ({
        key: null,
        watchProp: '$props',
        analyticsDataParams: {},
    }),

    /**
     * Adds watch callback for props or data.
     *
     * @returns {void}
     */
    mounted() {
        this.$watch(this.watchProp, this.watchCallback, {
            deep: true,
            immediate: true,
        });
    },

    computed: {
        /**
         * Returns prepared chart data.
         *
         * @returns {Array|null|boolean} Chart data.
         */
        chartData() {
            return this.analyticsData?.[this.key];
        },
    },

    methods: {
        /**
         * Loads top episodes for given props.
         *
         * @param  {object} props Current props.
         * @returns {void}
         */
        watchCallback({ from, showHash, to }) {
            if (this.waitUntilReady && ! this.ready) {
                return;
            }

            const key = getAnalyticsDataKey({
                ...omit(this.analyticsDataParams, ['limit']),
                from,
                showHash,
                to,
            });

            if (key === this.key) {
                return;
            }

            this.key = key;

            if (this.analyticsData?.[key] || false === this.analyticsData?.[key]) {
                return;
            }

            this.loadData && this.loadData({
                from,
                showHash,
                to,
                ...this.analyticsDataParams,
            });
        },
    },
};
